import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './Layout.css';

interface LayoutProps {
	children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
	const location = useLocation();
	const isHome = location.pathname === '/';

	return (
		<div className="layout">
			<Header />
			<main id="main-content" key={location.pathname} className={`main-content page-transition ${isHome ? 'main-content--home' : ''}`}>
				{children}
			</main>
			<Footer />
		</div>
	);
};

export default Layout;
